import Zoom from "react-medium-image-zoom"
import Image from "next/image"
import tw, { styled } from "twin.macro"
import { Dispatch, SetStateAction } from "react"
import { Attachment } from "airtable"

const StyledFrame = styled("div")(() => [
  tw`
    h-full w-full
    flex justify-center 
    relative
    max-h-[850px]
  `,
])

interface WorkImageProps {
  title: string
  caption: string
  image_url: string
  image_preview: Array<Attachment>
  setImageLoaded: Dispatch<SetStateAction<boolean>>
}

export const WorkImage = (props: WorkImageProps) => {
  const { image_url, image_preview, caption, setImageLoaded } = props

  // Get the width and height from the `image_preview` attachment thumbnamil field
  const mainImage = image_preview[0].thumbnails && image_preview[0].thumbnails.full
  const mainImageWidth = mainImage && mainImage.width
  const mainImageHeight = mainImage && mainImage.height

  const onLoadCallBack = () => {
    setImageLoaded(true)
  }

  const altText = caption
    ? `${caption.toString()} – The Richard Pousette-Dart Foundation`
    : `The Richard Pousette-Dart Foundation`

  return (
    <Zoom>
      <StyledFrame>
        <Image
          src={image_url}
          alt={altText}
          width={mainImageWidth}
          height={mainImageHeight}
          onLoadingComplete={onLoadCallBack}
          priority={true}
          sizes="100vw"
          style={{
            objectFit: "scale-down",
          }}
        />
      </StyledFrame>
    </Zoom>
  )
}
